// extracted by mini-css-extract-plugin
export default {"form":"styles_form__a2i15","editor":"styles_editor__kBck6"};